export default {"src":"/_next/static/media/ResearchAsstImage.19608840.svg","height":624,"width":869,"blurWidth":0,"blurHeight":0};